module.exports = __webpack_public_path__ + "static/media/slide3.566a4cea.png";